export default __webpack_public_path__ + "static/media/tiger-flip.7c0eedac.gif";